import {TranscriptionViewerAudioPlayer} from './transcription_viewer_audio_player'

/*
  Displays the view with the call audio in wave surfer and call transcription
*/
export class TranscriptionSearchViewer extends HTMLElement {
  constructor(hiddenElement, callid, audioSrc, domain_id) {
    super();

    this.callid = callid;
    this.domain_id = domain_id;
    this.hiddenElement = hiddenElement; // the element that was hidden to show this.
    this.audioSrc = audioSrc;

    this.rowData = $('.table').DataTable().row(`#${this.callid}`).data();
    console.log(this.rowData)
  }

  async connectedCallback() {
    this.innerHTML = `
      <div class='row'>
        <div id='transcription-viewer'>
          <div>
            <h3 class='title' style="float:left; margin-bottom:0px; font-size:18px;"><span id="location-back"></span>Call Transcript for ${Common.formatPhoneNumber(this.rowData.tracking)}
            </h3>
          </div>
          <br><br>
         


          <transcription-viewer-audio-player
            src="${this.audioSrc}"
          />
          </transcription-viewer-audio-player>
          
          <div class='row' id='data-container' style="margin-top: 40px">

             <div class='col-sm-4' id='keyword-container' style="padding-right: 24px">
              <div style="border: 1px solid #ccc; padding: 12px 6px; border-radius: 6px; margin-bottom: 20px">
                <div class="row">
                  <div class="col-xs-4 col-sm-5"><label>Time of Call:</label></div>
                  <div class="col-xs-8 col-sm-7">${moment.utc(this.rowData.call_start_time).local().format('MMM D, YYYY hh:mm:ss A')}</div>
                </div>
                
              <div class="row">
                <div class="col-xs-4 col-sm-5"><label>Call ID:</label></div>
                <div class="col-xs-8 col-sm-7">${Common.formatPhoneNumber(this.rowData.ani)}</div>
              </div>

              <div class="row">
                <div class="col-xs-4 col-sm-5"><label>Caller Name:</label></div>
                <div class="col-xs-8 col-sm-7">${_.capitalize(this.rowData.first_name)} ${_.capitalize(this.rowData.last_name)}</div>
              </div>

              <div class="row">
                <div class="col-xs-4 col-sm-5"><label>Tracking:</label></div>
                <div class="col-xs-8 col-sm-7">${Common.formatPhoneNumber(this.rowData.tracking)}</div>
              </div>

              <div class="row">
                <div class="col-xs-4 col-sm-5"><label>Representative Name:</label></div>
                <div class="col-xs-8 col-sm-7">${this.rowData.employeename}</div>
              </div>

              <div class="row">
                <div class="col-xs-4 col-sm-5"><label>Duration:</label></div>
                <div class="col-xs-8 col-sm-7">${moment.utc(moment.duration(parseInt(this.rowData.duration), 'seconds').asMilliseconds()).format('HH:mm:ss')}</div>
              </div>

              <div class="row">
                <div class="col-xs-4 col-sm-5"><label>Campaign Name:</label></div>
                <div class="col-xs-8 col-sm-7">${this.rowData.campaign}</div>
              </div>

              <div class="row">
                <div class="col-xs-4 col-sm-5"><label>Result:</label></div>
                <div class="col-xs-8 col-sm-7">${this.rowData.dialstatus}</div>
              </div>

            </div>

            <div class="keyword_form" style="padding:12px">
             <label>Keyword Search</label>
              <p>Identify specific keywords or key phrases in the call</p>

                <form id="keyword-search" class="row">
                  <div id='transcription-search-field' class="col-xs-9" style="padding-left:0px">
                     <input type="text" id="search-field" class="form-control" placeholder="e.g.: hello, thank you">
                   </div>
                  <div class="col-xs-3 pull-right">
                    <button id="search-button" class="btn btn-primary">Search</button>
                  </div>
                 </form>
              
              </div>

              <div id='transcription-keywords' style="margin: 0px 12px">
              </div>
            </div>


            <div class='col-sm-8' id='transcription-container' style="border: 1px solid #ccc; padding: 8px; border-radius: 6px">
              <div style="display:flex; justify-content:space-between; margin-bottom:6px;">
                <h2 class='heading' style="font-size: 16px; padding-left: 18px; padding-top: 4px">Transcript</h2>
              </div>

              <div id='transcription-text'>
                <h3>Loading transcript...</h3>
              </div>

            </div> 

          </div>

          <div class="row">
          <div class="col-md-4"></div>
          <div class="col-md-8">
             <div style="margin-top: 8px">
                <a class="btn btn-outline-secondary btn-sm"
                title="Export transcript to Excel"
                href="/transcript/${this.callid}/export">Export Transcript
                </a>
              </div>
          </div>
          </div>



        </div>
      </div>
    `;

    this.querySelector('#location-back').addEventListener('click', this.cancelEdit.bind(this));

    await this.loadTranscript();
  }

  using_https() {return ('https:' == document.location.protocol);}

  async loadTranscript() {
    try {
      this.disableKeywordSearchForm();
      let res = await fetch(`/transcript/${this.callid}/load`);
      let data = await res.json();
      // console.log("transcript: " + JSON.stringify(data.transcript))
      // console.log("keywords: " + JSON.stringify(data.keywords))
      if (data.error) {
        alert("Unable to find transcript. Error: " + data.error)
      }
      else {
        this.renderTranscript(data.transcript)
        this.renderSearchField()
      }
    }
    catch(err) {
      console.log("[loadTranscript] Failed: " + err)
    }  
  }


  renderTranscript(transcript){
    const container = this.querySelector('#transcription-text');
    if (container){
      container.innerHTML = "";
      container.appendChild(new TranscriptionContent3(transcript))
    }
  }
  
  enableKeywordSearchForm(){
    this.renderKeywordSearchForm(false)
  }
  disableKeywordSearchForm(){
    this.renderKeywordSearchForm(true)
  }
  renderKeywordSearchForm(flag) {
    $("form#keyword-search :input").prop('readonly', flag);  
  }
  
  renderSearchField(){

    // Make the search form enabled
    this.enableKeywordSearchForm()

    const button = this.querySelector('#search-button')
    if (button){
      button.addEventListener("click", function(e){
        e.preventDefault();

        const textField = this.querySelector('#search-field')
        if (textField){
          const v = textField.value.trim()
          if (v.length < 4) {
            alert("Please search for something longer.")
            return
          }

          // call api which calls CEP to search the transcript for the keyword data
          this.searchTranscript(v)
        }
      }.bind(this))
    }
  }

  async searchTranscript(query) {
    try {
      pageLoadingFrame("show");
      let res = await fetch(`/transcript/${this.callid}/search?q=${query}`);
      const data = await res.json();
      // console.log("query results: " + JSON.stringify(data))
      this.renderKeywords(data.keywords)

      // Click on the first keyword
      if (Object.keys(data.keywords).length > 0){
        const keyword_link = this.querySelector('.clickable-keyword')
        if (keyword_link){
          keyword_link.click()
        }
      }
    } catch (error) {
      console.error(error);
      Common.notify("Failed to search transcript", "error");
    }
    pageLoadingFrame("hide");
  }

  renderKeywords(keywords){
    const container = this.querySelector('#transcription-keywords');
    if (container){
      container.innerHTML = "";
      container.appendChild(new KeywordContent3(keywords))
    }
  }

  cancelEdit(e) {
    e.preventDefault();
    this.remove();
    this.hiddenElement.classList.remove('hidden');
  }

  disconnectedCallback() {
  }
}

customElements.define("transcription-search-viewer", TranscriptionSearchViewer);




class TranscriptionContent3 extends HTMLElement {
  constructor(data) {
    super();
    this.data = data;
  }

  connectedCallback() {
    this.innerHTML = ""
    
    if (this.data && this.data.length > 0) {
      this.data.forEach(element => {
        this.appendChild(new TranscriptionSentence3(element))
      })
    }
    else {
      this.innerHTML = `
        <div class='sentence-container'>
          <h4 class="no-data">No transcript data</h4>
        </div>
        `
    }

  }
}
customElements.define("transcription-content3", TranscriptionContent3);


function momentDurationToTime(dur) {
  var hours = Math.floor(dur.asHours());
  var mins  = Math.floor(dur.asMinutes()) - hours * 60;
  var sec   = Math.floor(dur.asSeconds()) - hours * 60 * 60 - mins * 60;

  return ((hours > 9) ? hours : ("0"+hours)) + ":" + ((mins > 9) ? mins : ("0"+mins)) + ":" + ((sec > 9) ? sec : ("0"+sec));
}

class TranscriptionSentence3 extends HTMLElement {
  constructor(data) {
    super();
    this.data = data;
    this.original_sentence = this.data.sentence;
    this.handleAudioPlayerTimeUpdate = this.handleAudioPlayerTimeUpdate.bind(this);
  }

  handleAudioPlayerTimeUpdate(e){
    this.data.sentence = this.original_sentence;

    if (this.isWithinCurrentTime(e.detail.currentTime)) {
      this.classList.add('currentSentence');
      this.scrollIntoView({behavior: 'smooth', block:
      'center'});  

      if (document.querySelector('keyword-content3').keyword_active === true) {
        const current_keyword = document.querySelector('keyword-element3.current .keyword-label')
        const current_keyword_text = current_keyword.innerText.trim();
        var keyword_index = this.data.sentence.toLowerCase().indexOf(current_keyword_text.toLowerCase());
        if (current_keyword && keyword_index !== -1){
          const highlighted_keyword_text = `<span class="current_keyword">${current_keyword_text}</span>`
  
          // Replace all instances of keyword (ignoring case) with <span>keyword</span>
          const regEx = new RegExp(current_keyword_text, "ig");
          this.data.sentence = this.data.sentence.replace(regEx, highlighted_keyword_text);
          document.querySelector('keyword-content3').keyword_active = false;
        }  
      }
      else {
        const current_keyword = document.querySelector('keyword-element3.current');
        if (current_keyword){
          current_keyword.classList.remove('current');
        }
      }
    }
    else {
      this.classList.remove('currentSentence');
    }
    this.render();
  }

  disconnectedCallback() {
    document.removeEventListener("audioPlayerTimeUpdate", this.handleAudioPlayerTimeUpdate);
  }


  render() {
    const formatted_start_time = momentDurationToTime(moment.duration(this.data.start_time, "seconds"));
    const formatted_end_time = momentDurationToTime(moment.duration(this.data.end_time, "seconds"));
    this.innerHTML = `
      <div class="row no-gutters">
        <div class="col-xs-3 col-sm-1 sentence-container ${this.data.speaker.toLowerCase()}">
          <p class="sentence-label" style="color:#003E80">${formatted_start_time}</p>
        </div>
        <div class="col-xs-9 col-sm-11 sentence-container ${this.data.speaker.toLowerCase()}" style="padding-bottom: 0px">
          <label class="sentence-label">${this.data.speaker}</label>
          <p class="sentence">${this.data.sentence}</p>
        </div>
      </div>

    `  
  }
  
  connectedCallback() {
    this.render();

    document.addEventListener("audioPlayerTimeUpdate", this.handleAudioPlayerTimeUpdate);

    this.addEventListener("click", (e)=>{
      this.dispatchTimeUpdateEvent()
    })
  }

  dispatchTimeUpdateEvent(){
    this.dispatchEvent(new CustomEvent('newSeekTimeForAudioPlayer', 
      {bubbles: true, detail: {newTime: this.data.start_time}}
    ))  
  }


  isWithinCurrentTime(currentTime) {
    return this.data.start_time <= currentTime && this.data.end_time >= currentTime;
  }
}
customElements.define("transcription-sentence3", TranscriptionSentence3);


/*
  Basic search field that when enter is pressed, searches the transcript JSON
  for all instances for the search phrase. The user will then be able to 
*/
class TranscriptSearchField extends HTMLElement {
  constructor(data) {
    super();
    this.data = data;
  }

  connectedCallback() {
    this.innerHTML = ""

      // Create the menu based on the call_types.call_type.name values
      const searchText = document.createElement('input');
      searchText.setAttribute('type','text');
      searchText.setAttribute('id','search_field');
      searchText.setAttribute('placeholder','Enter search phrase...');
      searchText.classList.add('form-control');
      searchText.onclick = this.callTypeMenuChanged.bind(this);
      this.appendChild(searchText);
      this.querySelector('#search_field').focus();
 
  }
  
  callTypeMenuChanged(e){
    const v = e.currentTarget.value;
    this.displaySelectedCallTypeKeywords(v);
  }

  displaySelectedCallTypeKeywords(callTypeName){
    // render call types of the selected call type

    // callTypeName is undefined, selected the first menu item
    if (typeof callTypeName === 'undefined'){
      callTypeName = this.querySelector('#call_type_menu:first-child').value;
    }

    // Find the matching keywords for the selected call type.
    const matchingCallTypeData = this.data.call_types.find(call_type => {
      return call_type.call_type.name === callTypeName;
    });
    this.buildCallTypeKeywordElements(matchingCallTypeData.call_type.keywords);
  }

  buildCallTypeKeywordElements(keywords){
    this.querySelectorAll('keyword-element3').forEach(el => el.remove());
    keywords.forEach(keywordEl => {
      this.appendChild(new KeywordElement3(keywordEl.keyword, keywordEl.matches))
    })
  }
}
customElements.define("transcript-search-field", TranscriptSearchField);

class KeywordContent3 extends HTMLElement {
  constructor(data) {
    super();
    this.data = data;
  }

  connectedCallback() {
    this.innerHTML = ""

    if (this.data){
      const keys = Object.keys(this.data);
      if (keys.length > 0) {
        keys.forEach(key => {
          this.appendChild(new KeywordElement3(key, this.data[key].matches))
        })
      }
    }
    else {
      this.innerHTML = `
        <div class='keyword-container'>
          <h4 class="no-data">No keyword data</h4>
        </div>
        `
    }  
  }
  
}
customElements.define("keyword-content3", KeywordContent3);

// This is the displayable keyword data.
// If there are multiple matches of a keyword, show pull down menu.
class KeywordElement3 extends HTMLElement {
  constructor(keyword, keyword_matches) {
    super();
    this.keyword = keyword;
    this.keyword_matches = keyword_matches;
  }

  connectedCallback() {
    this.innerHTML = `
      <div class='keyword-container'>
        <p>
          <span class="keyword-label">
            <strong>
              ${this.keyword}
            </strong>
          </span> - 
          <span>
            (${this.keyword_matches.length})
          </span>
        </p>
        <div class='keyword-matches'></div>
      </div>
    `

    this.renderKeywordHtml();
  }

  renderKeywordHtml() {
    const container = this.querySelector('.keyword-matches');
    if (! container) return;

    
    if (this.keyword_matches.length === 1) {
      this.createClickableTimeRange(this.keyword_matches[0], this.keyword, container);
    }
    else if (this.keyword_matches.length > 1) {
      const menu = document.createElement('select');
      menu.classList.add('keyword-select-menu')
      this.keyword_matches.forEach(match => {
        const formatted_start_time = momentDurationToTime(moment.duration(match.start_time, "seconds"));
        const formatted_end_time = momentDurationToTime(moment.duration(match.end_time, "seconds"));
        const time_range = `${formatted_start_time} - ${formatted_end_time}`
        const option = document.createElement('option');
        option.setAttribute('value', match.start_time)
        option.setAttribute('data-start-time', match.start_time);
        option.setAttribute('data-end-time', match.end_time);
        option.setAttribute('data-keyword', this.keyword);
        option.innerText = time_range;
        menu.appendChild(option);
      })

      container.appendChild(menu)

      menu.addEventListener('change',(e)=>{
        const option = e.currentTarget.options[e.currentTarget.selectedIndex]
        const start_time = Number(option.getAttribute('data-start-time'))
        const end_time = Number(option.getAttribute('data-end-time'))
        const keyword = option.getAttribute('data-keyword')
        const time_range = {"start_time": start_time, "end_time":end_time};
        const container = this.querySelector('.keyword-matches');
        this.createClickableTimeRange(time_range, keyword, container);
        this.dispatchTimeUpdateEvent(start_time, end_time, keyword);
      })

      // create the clickable time range for the first element
      this.createClickableTimeRange(this.keyword_matches[0], this.keyword, container);
    }
  }
  
  createClickableTimeRange(time_range, keyword, container){
    const clickable_keyword_container = this.querySelector('.clickable-keyword-container');
    if (clickable_keyword_container){
      clickable_keyword_container.remove()
    }

    const div = document.createElement('div');
    div.classList.add('clickable-keyword-container')
    const link = document.createElement('a');
    link.classList.add('clickable-keyword')
    link.setAttribute('title', 'Click to go to this keyword');
    link.setAttribute('data-start-time', time_range.start_time);
    link.setAttribute('data-end-time', time_range.end_time);

    const formatted_start_time = momentDurationToTime(moment.duration(time_range.start_time, "seconds"));
    const formatted_end_time = momentDurationToTime(moment.duration(time_range.end_time, "seconds"));
    link.innerText = `${formatted_start_time} - ${formatted_end_time}`
    div.appendChild(link);
    container.appendChild(div);

    link.addEventListener('click', (e)=>{
      e.preventDefault();
      const start_time = time_range.start_time;
      const end_time = time_range.end_time;
      this.dispatchTimeUpdateEvent(start_time, end_time, keyword);
    })
  }
  
  dispatchTimeUpdateEvent(start_time, end_time, keyword){
    const currentKeyword = document.querySelector('keyword-element3.current');
    if (currentKeyword && currentKeyword !== this) {
      currentKeyword.classList.remove('current')
    }
    if (!this.classList.contains('current')) {
      this.classList.add('current')
      document.querySelector('keyword-content3').keyword_active = true;
    }
    else {
      document.querySelector('keyword-content3').keyword_active = true;
    }
    
    this.dispatchEvent(new CustomEvent('newSeekTimeForAudioPlayer', 
      {bubbles: true, detail: {startTime: start_time, endTime: end_time, keyword: keyword}}
    ))  
  }

}
customElements.define("keyword-element3", KeywordElement3);
